export default {
  addPanel: 'Dodaj panel',
};
